module.exports = __webpack_public_path__ + "img/cover-woonwaard.983c2d74.jpg";